import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import type { AnalysisBriefing } from '../lib/types';
import styles from './AnalyticalBriefing.module.css';

interface Props {
  briefing: AnalysisBriefing;
  className?: string;
}

export function AnalyticalBriefing({ briefing, className }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <section className={[styles.wrap, className].filter(Boolean).join(' ')} aria-labelledby="briefing-heading">
      <button
        type="button"
        className={styles.toggle}
        aria-expanded={open}
        aria-controls="briefing-body"
        onClick={() => setOpen((o) => !o)}
      >
        <span className={styles.toggleLeft}>
          <span className={styles.eyebrow}>Analytical Briefing</span>
          <h2 id="briefing-heading" className={styles.heading}>
            The full read on tone, posture, and trajectory
          </h2>
        </span>
        <ChevronDown
          size={20}
          strokeWidth={1.5}
          className={[styles.chev, open ? styles.chevOpen : ''].join(' ')}
          aria-hidden="true"
        />
      </button>

      {open && (
        <div id="briefing-body" className={styles.body}>
          <div className={styles.lead}>
            <p>{briefing.overall}</p>
          </div>

          <div className={styles.grid}>
            <div className={styles.cell}>
              <h3 className={styles.cellHeading}>Dimension Breakdown</h3>
              <ul className={styles.dimList}>
                {briefing.dimensionBreakdown.map((d) => (
                  <li key={d.label} className={styles.dimItem}>
                    <span className={styles.dimLabel}>{d.label}</span>
                    <span className={styles.dimCopy}>{d.copy}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.cell}>
              <h3 className={styles.cellHeading}>Entity Sentiment Landscape</h3>
              <p>{briefing.entityLandscape}</p>
            </div>
            <div className={styles.cell}>
              <h3 className={styles.cellHeading}>Document Trajectory</h3>
              <p>{briefing.trajectory}</p>
            </div>
            <div className={styles.cell}>
              <h3 className={styles.cellHeading}>Linguistic Profile</h3>
              <p>{briefing.linguisticProfile}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
